// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__24904","list":"PatternAutocomplete_list__2qULE"};